
export const textCenter = (props) => {

    const valueAll = {
        xs: 'center',
        sm: 'center',
        md: 'center',
        lg: 'center',
        xl: 'center',

    }
    const value = {
        xs: 'center',
        sm: 'center',
        md: 'center',
        lg: 'start',
        xl: 'start',
    }

    if (props === 'all') {
        return (valueAll)
    } else if (props === 'underLg') {
        return (value)
    }

}

export const responsiveValue = (xs, sm, md, lg, xl, or) => {

    const layout = {
        xs: xs || or,
        sm: sm || or,
        md: md || or,
        lg: lg || or,
        xl: xl || or,
    }
    return layout

}

